import { useState } from "react";
import type { User } from "@printtat/shared";
import { cn } from "@/lib/utils";

interface ProfilePictureProps {
  user: User;
  className?: string;
}

export const ProfilePicture = ({ user, className }: ProfilePictureProps) => {
  const [imageError, setImageError] = useState(false);

  const getInitials = () => {
    const firstName = user.firstName || "";
    const lastName = user.lastName || "";
    
    if (firstName || lastName) {
      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
    }
    
    return user.email.charAt(0).toUpperCase();
  };

  const hasPicture = !!user.profilePicture;

  return (
    <div className={cn("flex items-center space-x-4", className)}>
      <div className="w-20 h-20 bg-indigo-600 rounded-full flex items-center justify-center text-white text-xl font-semibold">
        {hasPicture && !imageError ? (
          <img
            src={user.profilePicture!.startsWith('http') 
              ? user.profilePicture 
              : `${import.meta.env.VITE_API_URL || 'http://localhost:4000'}${user.profilePicture}`}
            alt={`${user.firstName} ${user.lastName}`}
            className="w-full h-full rounded-full object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          getInitials()
        )}
      </div>
      <div>
        <p className="text-sm text-gray-600">
          Profile picture upload coming soon
        </p>
      </div>
    </div>
  );
};
